var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "19px",
    viewBox: "0 0 29 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Foot") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humanuculus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.195858829
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-22",
    transform: "translate(-74.000000, -327.000000)",
    fill: "#1E428A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.231162,327 L86.7709748,342.039998 C85.8350654,343.418686 85.0893457,344.271719 84.5338159,344.599098 C82.3449969,345.888988 80.1633239,345.658593 78.9294795,345.411345 C77.2259042,345.069968 75.8540325,344.118866 74.8138645,342.558039 L76.5132487,327 L86.231162,327 Z M100.571591,327 L102.270975,342.558039 C101.230807,344.118866 99.8589351,345.069968 98.1553597,345.411345 C96.9215153,345.658593 94.7398424,345.888988 92.5510233,344.599098 C91.9954935,344.271719 91.2497739,343.418686 90.3138645,342.039998 L90.3138645,342.039998 L90.8536772,327 L100.571591,327 Z",
    id: "Foot"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoot);
export default __webpack_public_path__ + "static/media/Foot.e3742d0fbd3dc535403620c9726fb979.svg";
export { ForwardRef as ReactComponent };